import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, FormControl, Modal } from "react-bootstrap";

import { getBase64FromFile } from "utils/getBase64FromFile";
import { uploadResume } from "../actions";

export class UploadResume extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      fileUploaded: false,
    };
  }

  handleChangeAction = () => {
    this.props.changeAction(false);
  };

  handleChooseFile = (e) => {
    this.setState({ fileUploaded: e.target.files[0] });
  };

  handleUploadResume = () => {
    getBase64FromFile(this.state.fileUploaded).then((base64Resume) => {
      const base64withouMeta = base64Resume.split("base64,")[1];
      this.props.onUploadResume(
        base64withouMeta,
        this.state.fileUploaded.name,
        this.props.currentCandidateId,
        this.props.candidateStageId
      );
    });
    this.handleChangeAction();
  };

  render() {
    return (
      <div>
        <Modal.Header>
          <h4>Upload a Resume</h4>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Choose a file to upload.</strong>
          </p>
          <FormControl
            id="formControlsFile"
            type="file"
            onChange={this.handleChooseFile}
          />
          <br />
          Please note: it may take 10-15 seconds for resumes to upload and
          display on a candidate's profile
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.handleChangeAction}
            id="cancelUploadResume"
            variant="outline-primary"
            className="btn-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleUploadResume}
            disabled={!this.state.fileUploaded}
            id="uploadResume"
          >
            Upload Resume
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

UploadResume.propTypes = {
  changeAction: PropTypes.func,
  onUploadResume: PropTypes.func,
  currentCandidateId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  candidateStageId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
};

const mapDispatchToProps = (dispatch) => ({
  onUploadResume: (base64Resume, fileName, testTakerId, stageId) =>
    dispatch(uploadResume(base64Resume, fileName, testTakerId, stageId)),
});

export default connect(undefined, mapDispatchToProps)(UploadResume);
